import React from 'react';

import CreateAnalysisModal from 'analysis-tool/create-analysis-modal/CreateAnalysisModal';
import isCreateAnalysisEnabled from 'analysis-tool/isCreateAnalysisEnabled';
import {InsightsFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';
import runModal from 'ui-library/runModal';

import CreateAnalyticsDashboardModal from './CreateAnalyticsDashboardModal';

function handleClickCreateDashboard(): void {
  runModal(CreateAnalyticsDashboardModal, {});
}
interface CreateAnalyticsButtonProps {
  className?: string;
}

function CreateDashboardButton({className}: CreateAnalyticsButtonProps): JSX.Element {
  return (
    <Tooltip title="Create dashboard" placement={TooltipPlacement.BOTTOM}>
      <Button
        buttonStyle={ButtonStyle.SECONDARY}
        className={className}
        icon="compose"
        onClick={handleClickCreateDashboard}
        size={ButtonSize.SMALL}
        dataTestAttrs={{component: 'CreateAnalyticsDashboardButton', element: 'button'}}
      />
    </Tooltip>
  );
}

function CreateAnalysisButton({className}: CreateAnalyticsButtonProps): JSX.Element {
  return (
    <Tooltip title="Create analysis" placement={TooltipPlacement.BOTTOM}>
      <Button
        buttonStyle={ButtonStyle.SECONDARY}
        className={className}
        icon="compose"
        onClick={() => {
          runModal(CreateAnalysisModal, {});
        }}
        size={ButtonSize.SMALL}
      />
    </Tooltip>
  );
}

function CreateDashboardOrAnalysisDropdown({className}: CreateAnalyticsButtonProps): JSX.Element {
  const menu = (
    <Menu dropLeft={true} width={Menu.WIDTHS.MEDIUM} height={Menu.HEIGHTS.MEDIUM}>
      <Option icon={ModelTypeConstants.ANALYTICS_DASHBOARD} onSelect={handleClickCreateDashboard}>
        Dashboard
      </Option>
      <Option
        icon={ModelTypeConstants.ANALYSIS}
        onSelect={() => {
          runModal(CreateAnalysisModal, {});
        }}
      >
        Analysis
      </Option>
    </Menu>
  );

  return (
    <Dropdown menu={menu}>
      <span>
        <Button
          buttonStyle={ButtonStyle.SECONDARY}
          className={className}
          icon="compose"
          size={ButtonSize.SMALL}
          dataTestAttrs={{component: 'CreateAnalyticsDashboardButton', element: 'button'}}
        />
      </span>
    </Dropdown>
  );
}

export default function CreateAnalyticsDashboardButton(props: CreateAnalyticsButtonProps): JSX.Element {
  if (isCreateAnalysisEnabled() && isFeatureEnabled({feature: InsightsFeature.INSIGHTS_CREATE})) {
    return <CreateDashboardOrAnalysisDropdown className={props.className} />;
  } else if (isCreateAnalysisEnabled()) {
    return <CreateAnalysisButton className={props.className} />;
  }
  return <CreateDashboardButton className={props.className} />;
}
